import { render } from "./TagCard.vue?vue&type=template&id=9568be54&scoped=true&ts=true"
import script from "./TagCard.vue?vue&type=script&lang=ts"
export * from "./TagCard.vue?vue&type=script&lang=ts"

import "./TagCard.vue?vue&type=style&index=0&id=9568be54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9568be54"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QKnob from 'quasar/src/components/knob/QKnob.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QIcon,QCircularProgress,QLinearProgress,QBadge,QBtn,QInput,QItemSection,QSlider,QKnob,QCardActions});
